import PropTypes from 'prop-types';
import React from 'react';

const CalculatorOutput = props => {
  return (
    <div className='calculator__output'>
      <OutputTable {... props} />
      <OutputCard {... props} />
    </div>
  );
};

const OutputTable = props => {
  return (
    <output id='output__table'>
      <table>
        <caption>Property Tax Comparison</caption>
        <tbody>
          <tr>
            <td>My Current Property Taxes</td>
            <td>{props.countyCurrent}</td>
          </tr>
          <tr>
            <th colSpan='2'>My Estimated Property Taxes Under</th>
          </tr>
          <tr>
            <td>Proposed FY2020 School Board Budget</td>
            <td>{props.countyProposed}</td>
          </tr>
          <tr>
            <td>My Additional Increases</td>
            <td>{props.myIncreases}</td>
          </tr>
        </tbody>
        <tbody>
          <tr>
            <td>My Proposed Property Taxes</td>
            <td>{props.myAmount}</td>
          </tr>
          <tr>
            <td>My Proposed FY2020 Increase</td>
            <td>{props.myBudget}</td>
          </tr>
        </tbody>
      </table>
    </output>
  );
};

OutputTable.propTypes = {
  countyAmount: PropTypes.string,
  countyCurrent: PropTypes.string,
  countyProposed: PropTypes.string,
  myIncreases: PropTypes.string,
  myBudget: PropTypes.string,
  myAmount: PropTypes.string
};


const OutputCard = props => {
  return (
    <output id='output-figure'>
      <figure>
        <svg viewBox='0 0 360 240' id='card'>
          <style>
            {'text{fill:#ffffff;font-family:"Merriweather Sans",system-ui,sans-serif;font-weight:bold'}
          </style>
          <defs>
            <linearGradient x1='55.7063802%' y1='44.1624502%' x2='94.5084635%' y2='69.4570644%' id='card__gradient'>
              <stop stopColor='#3B71E8' offset='0%'></stop>
              <stop stopColor='#1E3567' offset='100%'></stop>
            </linearGradient>
          </defs>
          <g id='card__wrapper'>
            <rect id='card__bg' stroke='#ffffff' fill='url(#card__gradient)' x='0.5' y='0.824099723' width='360' height='240'></rect>
            <text id='card__description' x='180' y='30' fontSize='14'>
              <tspan textAnchor='middle'>My vision for Hamilton County schools</tspan>
              <tspan textAnchor='middle' x='180' y='48'>will cost my household an additional</tspan>
            </text>
            <text id='card__amount' x='180' y='120' textAnchor='middle' dominantBaseline='middle' fontSize='32'>
              {props.monthlyAmount} a month
            </text>
          </g>
        </svg>
      </figure>
    </output>
  );
};

OutputCard.propTypes = {
  monthlyAmount: PropTypes.string
};

export default CalculatorOutput;
